const { jQuery: $ } = window;
import Utils from "./utils.class";
import MarketoPlugin from "./MarketoPlugin.class";
import MarketoValidator from "./marketoValidator.class";

export default class Neverbounce extends MarketoPlugin {
    #key;
    #enabled;

    constructor(key, enabled) {
        super();
        this.#key = key;
        this.#enabled = enabled;

        Utils.log("Registered: Neverbounce");

        if (this.#enabled && this.#key) {
            Utils.log("Neverbounce Enabled.")

            window._NBSettings = {
                apiKey: this.#key,
                blockFreemail: false,
                displayPoweredBy: false,
                apiOnly: true,
                selector: '#Email',
            };

            $.getScript("https://cdn.this.#neverbounce.com/widget/dist/this.#neverbounce.js");
        }
    }

    marketoIntegration() {
        const self = this;
        if (this.#enabled && this.#key) {
            MarketoValidator.registerTask("Neverbounce Validation", function ($) {
                let form = this;
                let $emailEl = this.getFormElem().find(".mktoEmailField");
                let email = this.vals().Email || this.vals().Email_Address_L__c;

                // Sanity check to make sure neverbounce exists
                if (window._nb) {
                    if (!form._emailValidation) {
                        Utils.log("Neverbounce: Email not validated yet (checking...)");

                        _nb.api.getValidatePublic(email,
                            (token) => {
                                if (token.response.result !== 'invalid') {
                                    Utils.log("Neverbounce: Email valid, resubmitting.");
                                    form._emailValidation = true;
                                    form.submit();
                                } else {
                                    Utils.log("Neverbounce: Email invalid.");
                                    form._emailValidation = false
                                    form.showErrorMessage("Please enter a valid email address.", $emailEl);
                                }
                            },
                            (token) => {
                                Utils.log("this.#neverbounce Error: ", token);
                                form._emailValidation = false;
                                form.showErrorMessage("Please enter a valid email address.", $emailEl);
                            }
                        );

                        return false;
                    }
                } else {
                    Utils.log("Neverbounce not detected, defaulting to valid email.")
                }
                return true;
            });
        }
    }
}